export var TooltipBehavior;
(function (TooltipBehavior) {
    TooltipBehavior["Hover"] = "tooltip-hover";
    TooltipBehavior["Click"] = "tooltip-click";
    TooltipBehavior["Error"] = "tooltip-error";
})(TooltipBehavior || (TooltipBehavior = {}));
